import {Item} from "../api/dtos/dtos";
import * as React from "react";
import {Icon} from "antd";
import locales from "../locales";

export const renderItemProperties = (item: Item): React.ReactNode => {
  return (
    <div style={{display: "flex", alignItems: "center"}}>
      {item.checklistRequired &&
        <Icon
          type="file-done"
          theme="outlined"
          title={locales.checklist_required}
          style={{marginRight: 12, color: "orange"}}
        />
      }
      {item.details}
    </div>
  );
};


// WEBPACK FOOTER //
// ./src/item/item-property-renderer.tsx